import React, { useState } from 'react';
import moment from 'moment';

import WarningIcon from '@mui/icons-material/Warning';

import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import { DatePicker } from '@mui/x-date-pickers';

import HardwareList from '../../HardwareList';
import CaseAccordion from '../../CaseAccordion';
import NoAccess from '../../NoAccess';

import Button from '../../../../../shared/Button';
import Dropzone from '../../../../../shared/dropzone/Dropzone';

export const CmfStep3 = (props) => {
  const {
    classes,
    onClose,
    activeCase,
    updateCase,
    products,
    preopPlan,
    preopRejected,
    caseMaxilla,
    caseLeftMandible,
    caseRightMandible,
    caseGenioplasty,
    fileStatuses,
    fileTypes,
    statuses,
    caseNotifications,
    userId,
  } = props;

  const [preop, setPreop] = useState([]);
  const [maxillaList, setMaxillaList] = useState(caseMaxilla || []);
  const [leftMandibleList, setLeftMandibleList] = useState(caseLeftMandible || []);
  const [rightMandibleList, setRightMandibleList] = useState(caseRightMandible || []);
  const [genioplastyList, setGenioplastyList] = useState(caseGenioplasty || []);

  const requiredDate = activeCase?.date
    ? moment(activeCase.date).subtract(7, 'days')
    : moment();

  const [date, setDate] = useState(requiredDate);

  const handleRemovePreop = (name) => {
    setPreop(preop.filter((file) => file.name !== name));
  };

  /* -------------------- Maxilla -------------------- */

  const handleAddMaxilla = (product) => {
    const list = [...maxillaList];
    const item = list.find(
      (i) => i.product === product.product && i.category === product.category
    );

    if (item) {
      item.amount += Number(product.amount);
      setMaxillaList(list);
    } else {
      setMaxillaList([...maxillaList, product]);
    }
  };

  const handleRemoveMaxilla = (id) =>
    setMaxillaList(maxillaList.filter((i) => i.id !== id));

  const handleMaxillaChange = (id, key, value) => {
    const list = [...maxillaList];
    const item = list.find((i) => i.id === id);
    item[key] = value;
    setMaxillaList(list);
  };

  /* -------------------- Left Mandible -------------------- */

  const handleAddLeftMandible = (product) => {
    const list = [...leftMandibleList];
    const item = list.find(
      (i) => i.product === product.product && i.category === product.category
    );

    if (item) {
      item.amount += Number(product.amount);
      setLeftMandibleList(list);
    } else {
      setLeftMandibleList([...leftMandibleList, product]);
    }
  };

  const handleRemoveLeftMandible = (id) =>
    setLeftMandibleList(leftMandibleList.filter((i) => i.id !== id));

  const handleLeftMandibleChange = (id, key, value) => {
    const list = [...leftMandibleList];
    const item = list.find((i) => i.id === id);
    item[key] = value;
    setLeftMandibleList(list);
  };

  /* -------------------- Right Mandible -------------------- */

  const handleAddRightMandible = (product) => {
    const list = [...rightMandibleList];
    const item = list.find(
      (i) => i.product === product.product && i.category === product.category
    );

    if (item) {
      item.amount += Number(product.amount);
      setRightMandibleList(list);
    } else {
      setRightMandibleList([...rightMandibleList, product]);
    }
  };

  const handleRemoveRightMandible = (id) =>
    setRightMandibleList(rightMandibleList.filter((i) => i.id !== id));

  const handleRightMandibleChange = (id, key, value) => {
    const list = [...rightMandibleList];
    const item = list.find((i) => i.id === id);
    item[key] = value;
    setRightMandibleList(list);
  };

  /* -------------------- Genioplasty -------------------- */

  const handleAddGenioplasty = (product) => {
    const list = [...genioplastyList];
    const item = list.find(
      (i) => i.product === product.product && i.category === product.category
    );

    if (item) {
      item.amount += Number(product.amount);
      setGenioplastyList(list);
    } else {
      setGenioplastyList([...genioplastyList, product]);
    }
  };

  const handleRemoveGenioplasty = (id) =>
    setGenioplastyList(genioplastyList.filter((i) => i.id !== id));

  const handleGenioplastyChange = (id, key, value) => {
    const list = [...genioplastyList];
    const item = list.find((i) => i.id === id);
    item[key] = value;
    setGenioplastyList(list);
  };

  /* -------------------- Submit -------------------- */

  const handleSubmit = () => {
    const now = moment().format();

    const activity = [
      { ...caseNotifications[3].success, date: now, userId },
      { ...caseNotifications[3].file, date: now, userId },
      ...activeCase.activity,
    ];

    const files = [...activeCase.files];
    const newFiles = [];
    const preopFile = preop[0];

    if (preopFile) {
      files.unshift({
        id: `${activeCase.id}_${fileTypes.preop}_${preopFile.name}`,
        name: preopFile.name,
        type: fileTypes.preop,
        status: fileStatuses.PENDING,
        date: now,
        userId,
      });
      newFiles.push(preopFile);
    }

    const approvedPreop = files.find(
      (f) => f.type === fileTypes.preop && f.status === fileStatuses.APPROVED
    );

    updateCase(
      {
        ...activeCase,
        step: approvedPreop ? 5 : 4,
        activity,
        maxilla: maxillaList,
        leftMandible: leftMandibleList,
        rightMandible: rightMandibleList,
        genioplasty: genioplastyList,
        files,
        completionDates: {
          ...activeCase.completionDates,
          step3: now,
        },
        completedBy: {
          ...activeCase.completedBy,
          step3: userId,
        },
        status: statuses.inProgress,
        requiredDate: date.format(),
      },
      newFiles
    ).then(onClose);
  };

  return (
    <LocalizationProvider dateAdapter={AdapterMoment}>
      <div className="case-step-container">
        <div className="case-step-content">
          <div className="case-step-row">
            <div className="column">
              <div className="modal-item-circle">3</div>
            </div>

            <div className="modal-item-content">
              <div className="m-b-lg">Attach Pre Op Plan</div>

              {activeCase.access ? (
                <>
                  <div className="m-t-lg m-b-md">
                    <div className="secondary font-size-sm m-b-sm">
                      ATTACH PRE-OP PLAN (.pdf)
                    </div>

                    {preopRejected && (
                      <div className="alert warning m-b-md">
                        <div className="d-flex align-center">
                          <WarningIcon color="primary" />
                          <div>Pre-Op plan has been rejected</div>
                        </div>
                        {activeCase.notes?.step6 && (
                          <div className="m-t-md">
                            Note: {activeCase.notes.step6}
                          </div>
                        )}
                      </div>
                    )}

                    <Dropzone
                      files={preop}
                      onUpload={setPreop}
                      type="pdf"
                      icon="preop"
                      multiple={false}
                      onRemove={handleRemovePreop}
                    />
                  </div>

                  <HardwareList
                    classes={classes}
                    hardwareList={maxillaList}
                    products={products}
                    onAdd={handleAddMaxilla}
                    onRemove={handleRemoveMaxilla}
                    onChange={(id, product) =>
                      handleMaxillaChange(id, 'product', product)
                    }
                    onAmountChange={(id, v) =>
                      handleMaxillaChange(id, 'amount', v)
                    }
                    onCategoryChange={(id, v) =>
                      handleMaxillaChange(id, 'category', v)
                    }
                    title="Maxilla"
                    procedureFlow={activeCase.procedureFlow}
                  />

                  <HardwareList
                    classes={classes}
                    hardwareList={leftMandibleList}
                    products={products}
                    onAdd={handleAddLeftMandible}
                    onRemove={handleRemoveLeftMandible}
                    onChange={(id, product) =>
                      handleLeftMandibleChange(id, 'product', product)
                    }
                    onAmountChange={(id, v) =>
                      handleLeftMandibleChange(id, 'amount', v)
                    }
                    onCategoryChange={(id, v) =>
                      handleLeftMandibleChange(id, 'category', v)
                    }
                    title="Left Mandible"
                    procedureFlow={activeCase.procedureFlow}
                  />

                  <HardwareList
                    classes={classes}
                    hardwareList={rightMandibleList}
                    products={products}
                    onAdd={handleAddRightMandible}
                    onRemove={handleRemoveRightMandible}
                    onChange={(id, product) =>
                      handleRightMandibleChange(id, 'product', product)
                    }
                    onAmountChange={(id, v) =>
                      handleRightMandibleChange(id, 'amount', v)
                    }
                    onCategoryChange={(id, v) =>
                      handleRightMandibleChange(id, 'category', v)
                    }
                    title="Right Mandible"
                    procedureFlow={activeCase.procedureFlow}
                  />

                  <HardwareList
                    classes={classes}
                    hardwareList={genioplastyList}
                    products={products}
                    onAdd={handleAddGenioplasty}
                    onRemove={handleRemoveGenioplasty}
                    onChange={(id, product) =>
                      handleGenioplastyChange(id, 'product', product)
                    }
                    onAmountChange={(id, v) =>
                      handleGenioplastyChange(id, 'amount', v)
                    }
                    onCategoryChange={(id, v) =>
                      handleGenioplastyChange(id, 'category', v)
                    }
                    title="Genioplasty"
                    procedureFlow={activeCase.procedureFlow}
                  />

                  <div className="hardware-list-container">
                    <div className="hardware-list-header">
                      <div className="secondary font-size-sm">
                        REQUIRED DATE
                      </div>
                    </div>

                    <DatePicker
                      desktopModeMediaQuery="(min-width: 0px)"
                      value={date}
                      onChange={(newDate) => setDate(newDate)}
                      format="DD/MM/YYYY"
                      slotProps={{
                        textField: {
                          variant: 'standard',
                        },
                      }}
                    />
                  </div>
                </>
              ) : (
                <NoAccess />
              )}
            </div>
          </div>

          <CaseAccordion currentStep={3} />
        </div>

        <div className="case-modal-actions">
          <div className="secondary pointer" onClick={onClose}>
            Close
          </div>
          <Button
            text="Submit"
            color="primary"
            onClick={handleSubmit}
            disabled={
              !activeCase.access ||
              (!preopPlan && !preop.length) ||
              !maxillaList.length
            }
          />
        </div>
      </div>
    </LocalizationProvider>
  );
};
